<template>
    <div>
        <header-vue></header-vue>
        <div style="height: 40px"></div>
        <div class="banner">
            <div class="container content g-mb-30">
        <div class="u-heading-v2-3--bottom g-brd-primary g-mb-30 text-center">
            <h1 class="h2 text-uppercase u-heading-v2__title g-mb-10">よくあるご質問</h1>
            <h4 class="g-font-size-14 g-mb-10 text-left">携帯の買取に関してよく寄せられるご質問及び、その回答を掲載しています。
                問題が解決できなかった場合は、お電話やメールにてお気軽にお問い合わせください。</h4>
        </div>
        <div id="accordion-17" class="u-accordion u-accordion-bg-primary u-accordion-color-white" role="tablist" aria-multiselectable="true">

            <!-- Question1 -->
            <div class="card g-brd-none rounded-0 g-mb-15">
                <div id="accordion-17-heading-01" class="u-accordion__header g-pa-0" role="tab">
                    <h5 class="mb-0">
                        <a class="d-flex g-color-main g-text-underline--none--hover g-brd-around g-brd-gray-light-v4 g-rounded-5 g-pa-10-15 collapsed" aria-expanded="false" aria-controls="accordion-17-body-01" data-toggle="collapse" data-parent="#accordion-17">
            <span class="u-accordion__control-icon g-mr-10">
              <i class="fa fa-angle-down"></i>
              <i class="fa fa-angle-up"></i>
            </span><font _mstmutation="1">
                            白ロムとはなんですか？
                        </font></a>
                    </h5>
                </div>
                <div id="accordion-17-body-01" class="collapse" role="tabpanel" aria-labelledby="accordion-17-heading-01" data-parent="#accordion-17" style="">
                    <div class="u-accordion__body g-bg-gray-light-v4">
                        <p class="card-text g-font-weight-600">何も情報が入っていない携帯端末のことです。</p>
                        <p class="card-text">
                            携帯電話に電話番号などの情報が入っていない状態、もしくは解約や機種変更などによってそれまで書き込まれていた情報が消去された状態の端末本体を「白ロム」といいます。</p>
                    </div>
                </div>
            </div>
            <!-- End Question1 -->

            <!-- Question2 -->
            <div class="card g-brd-none rounded-0 g-mb-15">
                <div id="accordion-17-heading-02" class="u-accordion__header g-pa-0" role="tab">
                    <h5 class="mb-0">
                        <a class="d-flex g-color-main g-text-underline--none--hover g-brd-around g-brd-gray-light-v4 g-rounded-5 g-pa-10-15 collapsed" aria-expanded="false" aria-controls="accordion-17-body-02" data-toggle="collapse" data-parent="#accordion-17">
            <span class="u-accordion__control-icon g-mr-10">
              <i class="fa fa-angle-down"></i>
              <i class="fa fa-angle-up"></i>
            </span><font _mstmutation="1">
                            買取後の携帯電話はどうなりますか？
                        </font></a>
                    </h5>
                </div>
                <div id="accordion-17-body-02" class="collapse" role="tabpanel" aria-labelledby="accordion-17-heading-02" data-parent="#accordion-17" style="">
                    <div class="u-accordion__body g-bg-gray-light-v4">
                        <p class="card-text g-font-weight-600">再販いたします</p>
                        <p class="card-text">
                            お客様から買取させていただいた携帯電話・スマートフォンは、クリーニングと端末内のデータを完全消去した状態で、リユース品として商品化し販売いたします。</p>
                    </div>
                </div>
            </div>
            <!-- End Question2 -->

            <!-- Question3 -->
            <div class="card g-brd-none rounded-0 g-mb-15">
                <div id="accordion-17-heading-03" class="u-accordion__header g-pa-0" role="tab">
                    <h5 class="mb-0">
                        <a class="d-flex g-color-main g-text-underline--none--hover g-brd-around g-brd-gray-light-v4 g-rounded-5 g-pa-10-15 collapsed" aria-expanded="false" aria-controls="accordion-17-body-03" data-toggle="collapse" data-parent="#accordion-17">
          <span class="u-accordion__control-icon g-mr-10">
            <i class="fa fa-angle-down"></i>
            <i class="fa fa-angle-up"></i>
          </span><font _mstmutation="1">
                            個人情報やデータの流出の心配はないでしょうか？
                        </font></a>
                    </h5>
                </div>
                <div id="accordion-17-body-03" class="collapse" role="tabpanel" aria-labelledby="accordion-17-heading-03" data-parent="#accordion-17" style="">
                    <div class="u-accordion__body g-bg-gray-light-v4">
                        <p class="card-text g-font-weight-600">データ流出の心配はありません</p>
                        <p class="card-text">
                            携帯電話内のデータやメモリに関しては、原則としてお客様ご自身で初期化（データ一括削除）して頂いておりますが、万全を期すために当社でも買取時および検品時に全ての端末（携帯電話・スマートフォン・タブレットなど）の初期化を行います。<br>
                            当社の初期化作業は、同一商品を複数名で手作業で実施し、個人情報の流出防止をしております。また、手作業に加えて消去ソフトも併用して初期化を行なっております。
                    </p></div>
                </div>
            </div>
            <!-- End Question3 -->

            <!-- Question4 -->
            <div class="card g-brd-none rounded-0 g-mb-15">
                <div id="accordion-17-heading-04" class="u-accordion__header g-pa-0" role="tab">
                    <h5 class="mb-0">
                        <a class="d-flex g-color-main g-text-underline--none--hover g-brd-around g-brd-gray-light-v4 g-rounded-5 g-pa-10-15 collapsed" aria-expanded="false" aria-controls="accordion-17-body-04" data-toggle="collapse" data-parent="#accordion-17">
          <span class="u-accordion__control-icon g-mr-10">
            <i class="fa fa-angle-down"></i>
            <i class="fa fa-angle-up"></i>
          </span><font _mstmutation="1">
                            古い携帯ですが、買い取りしてもらえるのでしょうか？
                        </font></a>
                    </h5>
                </div>
                <div id="accordion-17-body-04" class="collapse" role="tabpanel" aria-labelledby="accordion-17-heading-04" data-parent="#accordion-17" style="">
                    <div class="u-accordion__body g-bg-gray-light-v4">
                        <p class="card-text g-font-weight-600">買取一丁目ウェブサイトに掲載がある機種は可能です</p>
                        <p class="card-text">状態にもよりますが、ウェブサイトに買取価格が掲載されている機種であれば、基本的に買取いたします。<br>
                            掲載されていない機種はお電話、メール等でお問い合わせください。<br>
                            ※お断りさせていただく場合もございますので、あらかじめご了承ください。</p>
                    </div>
                </div>
            </div>
            <!-- End Question4 -->

            <!-- Question5 -->
            <div class="card g-brd-none rounded-0 g-mb-15">
                <div id="accordion-17-heading-05" class="u-accordion__header g-pa-0" role="tab">
                    <h5 class="mb-0">
                        <a class="d-flex g-color-main g-text-underline--none--hover g-brd-around g-brd-gray-light-v4 g-rounded-5 g-pa-10-15 collapsed" aria-expanded="false" aria-controls="accordion-17-body-05" data-toggle="collapse" data-parent="#accordion-17">
          <span class="u-accordion__control-icon g-mr-10">
            <i class="fa fa-angle-down"></i>
            <i class="fa fa-angle-up"></i>
          </span><font _mstmutation="1">
                            海外の携帯電話も買取可能ですか？
                        </font></a>
                    </h5>
                </div>
                <div id="accordion-17-body-05" class="collapse" role="tabpanel" aria-labelledby="accordion-17-heading-05" data-parent="#accordion-17" style="">
                    <div class="u-accordion__body g-bg-gray-light-v4">
                        <p class="card-text g-font-weight-600">はい、買取可能です</p>
                        <p class="card-text">機種によって買取可能です。<br>ただし、技適マークのない端末は買取ができません。
                        </p>
                    </div>
                </div>
            </div>
            <!-- End Question5 -->

            <!-- Question6 -->
            <div class="card g-brd-none rounded-0 g-mb-15">
                <div id="accordion-17-heading-06" class="u-accordion__header g-pa-0" role="tab">
                    <h5 class="mb-0">
                        <a class="d-flex g-color-main g-text-underline--none--hover g-brd-around g-brd-gray-light-v4 g-rounded-5 g-pa-10-15 collapsed" aria-expanded="false" aria-controls="accordion-17-body-06" data-toggle="collapse" data-parent="#accordion-17">
          <span class="u-accordion__control-icon g-mr-10">
            <i class="fa fa-angle-down"></i>
            <i class="fa fa-angle-up"></i>
          </span><font _mstmutation="1">
                            本体のみでも買取可能ですか？
                        </font></a>
                    </h5>
                </div>
                <div id="accordion-17-body-06" class="collapse" role="tabpanel" aria-labelledby="accordion-17-heading-06" data-parent="#accordion-17" style="">
                    <div class="u-accordion__body g-bg-gray-light-v4">
                        <p class="card-text g-font-weight-600">はい、買取可能です</p>
                        <p class="card-text"><font _mstmutation="1">
                            買取可能です。ただし、当サイトの買取参考価格は、新品未使用品（外箱に保護フィルムが付いている状態）で本体・付属品・箱・保証書等がすべて揃った状態の買取上限金額となっております。保護フィルム・付属品・保証書等がない場合、買取価格が減額になることがございます。</font><br>
                    </p></div>
                </div>
            </div>
            <!-- End Question6 -->

            <!-- Question7 -->
            <div class="card g-brd-none rounded-0 g-mb-15">
                <div id="accordion-17-heading-07" class="u-accordion__header g-pa-0" role="tab">
                    <h5 class="mb-0">
                        <a class="d-flex g-color-main g-text-underline--none--hover g-brd-around g-brd-gray-light-v4 g-rounded-5 g-pa-10-15 collapsed" aria-expanded="false" aria-controls="accordion-17-body-07" data-toggle="collapse" data-parent="#accordion-17">
          <span class="u-accordion__control-icon g-mr-10">
            <i class="fa fa-angle-down"></i>
            <i class="fa fa-angle-up"></i>
          </span><font _mstmutation="1">
                            端末代金の残債のあるものも買取可能ですか？
                        </font></a>
                    </h5>
                </div>
                <div id="accordion-17-body-07" class="collapse" role="tabpanel" aria-labelledby="accordion-17-heading-07" data-parent="#accordion-17" style="">
                    <div class="u-accordion__body g-bg-gray-light-v4">
                        <p class="card-text g-font-weight-600">はい、買取可能です</p>
                        <p class="card-text">各キャリアの「ネットワーク利用制限確認サイト」にて調査の上、判定が「○」か「△」であれば買取可能です。<br>判定が「×」の場合は買取不可となります（○は通常価格、△は【利用制限△】価格での買取となり、通常価格と異なります）。
                        </p>
                        <p class="card-text g-font-weight-400">主要キャリアの利用制限確認サイト</p>
                        <ul>
                            <li><a href="http://nw-restriction.nttdocomo.co.jp/top.php" target="_blank">docomoネットワーク利用制限確認サイト</a>
                            </li>
                            <li><a href="https://www.au.com/support/service/mobile/network-riyoseigen/" target="_blank">auネットワーク利用制限確認サイト</a>
                            </li>
                            <li><a href="https://www.softbank.jp/mobile/support/3g/restriction/" target="_blank">SoftBankネットワーク利用制限確認サイト</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- End Question7 -->

            <!-- Question8 -->
            <div class="card g-brd-none rounded-0 g-mb-15">
                <div id="accordion-17-heading-08" class="u-accordion__header g-pa-0" role="tab">
                    <h5 class="mb-0">
                        <a class="collapsed d-flex g-color-main g-text-underline--none--hover g-brd-around g-brd-gray-light-v4 g-rounded-5 g-pa-10-15" aria-expanded="false" aria-controls="accordion-17-body-08" data-toggle="collapse" data-parent="#accordion-17">
          <span class="u-accordion__control-icon g-mr-10">
            <i class="fa fa-angle-down"></i>
            <i class="fa fa-angle-up"></i>
          </span><font _mstmutation="1">
                            発送前の注意点はありますか？
                        </font></a>
                    </h5>
                </div>
                <div id="accordion-17-body-08" class="collapse" role="tabpanel" aria-labelledby="accordion-17-heading-08" data-parent="#accordion-17">
                    <div class="u-accordion__body g-bg-gray-light-v4">
                        <p class="card-text g-font-weight-600">発送時は以下にご注意の上、お送りください</p>
                        <p class="card-text">
                        </p><ul>
                            <li>
                                個人情報保護の為、ICアプリ・生活アプリ等を全て削除し、必ず全てのデータをお客様がオールリセット（初期化）を行ってください。
                            </li>
                            <li>iPhoneについては「iPhoneを探すをオフ」→「iCloudをログアウト」→「すべてのコンテンツと設定の消去」にて初期化の上、ホーム画面に戻してからお送りください。
                                <br>※iOSのバージョンによってはホーム画面の状態で無い場合、お買取りが出来ない場合がございます。
                            </li>
                            <li>おサイフケータイ等のICアプリ・生活アプリは、登録時のSIMカード以外では消去できませんので
                                必ずお客様自身で全て削除をお願い致します。
                            </li>
                            <li>オールリセットをしても暗証番号やアプリまで全て初期状態に戻るわけではないので
                                十分ご確認ください。ご不明な点はキャリアショップにてご確認お願い致します。
                            </li>
                            <li>
                                また、買取申込書と身分証のコピー(現住所記載面を含む)の同封もお忘れない様、お願い致します。
                            </li>
                        </ul>
                        <p></p>
                    </div>
                </div>
            </div>
            <!-- End Question8 -->

            <!-- Question9 -->
            <div class="card g-brd-none rounded-0 g-mb-15">
                <div id="accordion-17-heading-09" class="u-accordion__header g-pa-0" role="tab">
                    <h5 class="mb-0">
                        <a class="collapsed d-flex g-color-main g-text-underline--none--hover g-brd-around g-brd-gray-light-v4 g-rounded-5 g-pa-10-15" aria-expanded="false" aria-controls="accordion-17-body-09" data-toggle="collapse" data-parent="#accordion-17">
          <span class="u-accordion__control-icon g-mr-10">
            <i class="fa fa-angle-down"></i>
            <i class="fa fa-angle-up"></i>
          </span><font _mstmutation="1">
                            本人確認書類にはどのようなものがありますか？
                        </font></a>
                    </h5>
                </div>
                <div id="accordion-17-body-09" class="collapse" role="tabpanel" aria-labelledby="accordion-17-heading-09" data-parent="#accordion-17">
                    <p class="u-accordion__body g-bg-gray-light-v4">
                    </p><p class="card-text g-font-weight-600">ご本人確認書類は次のようになります。<br>郵送買取ではお支払方法によりご本人確認書類が異なりますので、ご注意ください。
                    </p>
                    <p class="card-text"><strong>【口座振込ご希望の場合】</strong>
                    </p><ul class="g-mt-minus-10">
                        <li>住民票の写し（原本）　※マイナンバーの記載がないもの</li>
                        <li>戸籍謄本（原本）　※現住所の記載があるもの</li>
                        <li>印鑑証明書（原本）</li>
                        <li>運転免許証のコピー（表裏）　※当社のご利用2回目以降のお客様に限ります</li>
                        <li>マイナンバーカード（表面）のコピー　※ご本人の店頭持ち込みに限ります</li>
                    </ul><font _mstmutation="1">
                    上記いずれかのご用意をお願いいたします。発行より3ヶ月以内のものが有効となります。</font><p></p>
                    <p class="card-text g-color-red">口座振込ご希望で、当店のご利用が初回、または振込口座が前回と異なる方は下記をご用意下さい。
                    </p><ul class="g-mt-minus-10">
                        <li>キャッシュカード表面のコピー、または銀行通帳のコピー（口座番号とお名前がわかるもの）</li>
                    </ul>
                    <p></p>
                    <p class="card-text"><strong>【現金書留ご希望の場合】</strong></p>
                    <p class="card-text">
                    </p><ul class="g-mt-minus-10">
                        <li>運転免許証のコピー（表裏）</li>
                        <li>旅券（パスポート）のコピー（写真面と住所記載面）</li>
                        <li>健康保険証のコピー（表裏）　※裏面に住所が記入されているもの</li>
                        <li>官公庁および特殊法人の身分証明書のコピー（写真付きのもの）</li>
                        <li>在留カードのコピー（表裏）</li>
                    </ul><font _mstmutation="1">
                    上記いずれかひとつをご用意ください。
                    </font><p></p>
                </div>
            </div>
            <!-- End Question9 -->

            <!-- Question10 -->
            <div class="card g-brd-none rounded-0 g-mb-15">
                <div id="accordion-17-heading-10" class="u-accordion__header g-pa-0" role="tab">
                    <h5 class="mb-0">
                        <a class="collapsed d-flex g-color-main g-text-underline--none--hover g-brd-around g-brd-gray-light-v4 g-rounded-5 g-pa-10-15" aria-expanded="false" aria-controls="accordion-17-body-10" data-toggle="collapse" data-parent="#accordion-17">
          <span class="u-accordion__control-icon g-mr-10">
            <i class="fa fa-angle-down"></i>
            <i class="fa fa-angle-up"></i>
          </span><font _mstmutation="1">
                            買取価格はいくらですか？
                        </font></a>
                    </h5>
                </div>
                <div id="accordion-17-body-10" class="collapse" role="tabpanel" aria-labelledby="accordion-17-heading-10" data-parent="#accordion-17">
                    <div class="u-accordion__body g-bg-gray-light-v4">
                        <p class="card-test">あくまでも参考価格になりますが、当サイトにてご確認いtだけます。<br>なお、買取価格は在庫状況、市場価格、商品状態などにより変動しており、サイト上の価格も随時更新しております。<br>※当サイト掲載の買取参考価格は「新品未使用」とな利、新品未使用での買取上限金額となっております（新品未使用は外箱の保護フィルムがついており、本体、付属品、箱、保証書など欠品が無い状態になります）。
                        </p>
                    </div>
                </div>
            </div>
            <!-- End Question10 -->

            <!-- Question11 -->
            <div class="card g-brd-none rounded-0 g-mb-15">
                <div id="accordion-17-heading-11" class="u-accordion__header g-pa-0" role="tab">
                    <h5 class="mb-0">
                        <a class="collapsed d-flex g-color-main g-text-underline--none--hover g-brd-around g-brd-gray-light-v4 g-rounded-5 g-pa-10-15" aria-expanded="false" aria-controls="accordion-17-body-11" data-toggle="collapse" data-parent="#accordion-17">
              <span class="u-accordion__control-icon g-mr-10">
                <i class="fa fa-angle-down"></i>
                <i class="fa fa-angle-up"></i>
              </span><font _mstmutation="1">
                            予約した買取価格はいつまで有効ですか？
                        </font></a>
                    </h5>
                </div>
                <div id="accordion-17-body-11" class="collapse" role="tabpanel" aria-labelledby="accordion-17-heading-11" data-parent="#accordion-17">
                    <div class="u-accordion__body g-bg-gray-light-v4">
                        <p class="card-text g-font-weight-600">予約確定時点の価格が適用されます。</p>
                        <p class="card-text">
                            ※来店予約は当日来店のみとさせて頂きます。<br>
                            ※郵送予約は当日予約、当日発送のみ予約時の価格を保証いたします。（土、日曜日の予約は月曜着も受け付けております。）
                        </p>
                    </div>
                </div>
            </div>
            <!-- End Question11 -->

            <!-- Question12 -->
            <div class="card g-brd-none rounded-0 g-mb-15">
                <div id="accordion-17-heading-12" class="u-accordion__header g-pa-0" role="tab">
                    <h5 class="mb-0">
                        <a class="collapsed d-flex g-color-main g-text-underline--none--hover g-brd-around g-brd-gray-light-v4 g-rounded-5 g-pa-10-15" aria-expanded="false" aria-controls="accordion-17-body-12" data-toggle="collapse" data-parent="#accordion-17">
                    <span class="u-accordion__control-icon g-mr-10">
                      <i class="fa fa-angle-down"></i>
                      <i class="fa fa-angle-up"></i>
                    </span><font _mstmutation="1">
                            買取申込後にサイトを見たら金額が変わっていました。買取金額はどうなりますか？
                        </font></a>
                    </h5>
                </div>
                <div id="accordion-17-body-12" class="collapse" role="tabpanel" aria-labelledby="accordion-17-heading-12" data-parent="#accordion-17">
                    <div class="u-accordion__body g-bg-gray-light-v4">
                        <p class="card-text g-font-weight-600">申込時の買取価格となります</p>
                        <p class="card-text">お申込後にサイトに掲載の金額が上がっても下がっても、お申し込みいただいたときの価格にて買取いたします。<br>
                            ※価格保証は買取申込の翌日の午前中までに店舗に商品が到着したものに限ります。</p>
                    </div>
                </div>
            </div>
            
            <div class="card g-brd-none rounded-0 g-mb-15">
                <div id="accordion-17-heading-15" class="u-accordion__header g-pa-0" role="tab">
                    <h5 class="mb-0">
                        <a class="collapsed d-flex g-color-main g-text-underline--none--hover g-brd-around g-brd-gray-light-v4 g-rounded-5 g-pa-10-15" aria-expanded="false" aria-controls="accordion-17-body-15" data-toggle="collapse" data-parent="#accordion-17">
          <span class="u-accordion__control-icon g-mr-10">
            <i class="fa fa-angle-down"></i>
            <i class="fa fa-angle-up"></i>
          </span><font _mstmutation="1">
                            振込手数料や送金手数料はどうなりますでしょうか？
                        </font></a>
                    </h5>
                </div>
                <div id="accordion-17-body-15" class="collapse" role="tabpanel" aria-labelledby="accordion-17-heading-15" data-parent="#accordion-17">
                    <div class="u-accordion__body g-bg-gray-light-v4">
                        <p class="card-text g-font-weight-600">金額により異なります</p>
                        <p class="card-text">振込手数料は買取金額10,000円以下の場合、330円かかります。<br>
                            10,000円以上は手数料無料です。<br>
                            ※現金書留は50万円単位で2,000円の手数料がかかります。</p>
                    </div>
                </div>
            </div>
            <!-- End Question15 -->

            <!-- Question16 -->
            <div class="card g-brd-none rounded-0 g-mb-15">
                <div id="accordion-17-heading-16" class="u-accordion__header g-pa-0" role="tab">
                    <h5 class="mb-0">
                        <a class="collapsed d-flex g-color-main g-text-underline--none--hover g-brd-around g-brd-gray-light-v4 g-rounded-5 g-pa-10-15" aria-expanded="false" aria-controls="accordion-17-body-16" data-toggle="collapse" data-parent="#accordion-17">
            <span class="u-accordion__control-icon g-mr-10">
              <i class="fa fa-angle-down"></i>
              <i class="fa fa-angle-up"></i>
            </span><font _mstmutation="1">
                            買取代金の振込先を家族の口座にできますか？
                        </font></a>
                    </h5>
                </div>
                <div id="accordion-17-body-16" class="collapse" role="tabpanel" aria-labelledby="accordion-17-heading-16" data-parent="#accordion-17">
                    <div class="u-accordion__body g-bg-gray-light-v4">
                        <p class="card-text g-font-weight-600">申込者ご本人の口座になります</p>
                        <p class="card-text">申し訳ありませんが、買取代金のお振込は申込者ご本人の口座になります。<br>お振込先ご本人様で買取のお申し込みを願いいたします。
                        </p>
                    </div>
                </div>
            </div>
            <!-- End Question16 -->

            <!-- Question17 -->
            
        </div>

    </div>
        </div>

        <FooterVue></FooterVue>
    </div>
</template>

<script>
import HeaderVue from "../components/Header.vue";
import FooterVue from "../components/FFooter.vue";
export default {
    components: { HeaderVue, FooterVue },
    props: {},
    data() {
        return {};
    },
    mounted() { },
    methods: {},
};
</script>
<style scoped>
.banner {
    width: 77vw;
    margin: 0px auto;
    padding: 20px 0;
    box-sizing: border-box;
    color: #555;
}
</style>